import type { BlogPost } from "./blog";

export const BLOG_RESTAURANTS_PART1: BlogPost[] = [
  {
    "slug": "restorany-tsentralnyy-rayon-spb",
    "title": "Рестораны Центрального района Санкт-Петербурга: лучшие места",
    "metaTitle": "Рестораны Центрального района СПб — лучшие места 2026 | Паруса на крыше",
    "metaDescription": "Рестораны Центрального района Санкт-Петербурга: обзор лучших заведений по кухне, атмосфере и ценам. Где поесть в историческом центре СПб в 2026 году.",
    "keywords": "рестораны центральный район спб, рестораны центральный район санкт-петербург, где поесть центр петербург",
    "date": "2026-06-01",
    "category": "Гид по городу",
    "readTime": 8,
    "image": "/photos/view_day.webp",
    "lead": "Центральный район Санкт-Петербурга — это Невский проспект, Казанский собор, Дворцовая площадь и сотни ресторанов на любой вкус. Разобраться в этом разнообразии непросто. Собрали честный гид по форматам и ориентирам.",
    "sections": [
      {
        "heading": "Чем отличается гастрономия центра",
        "body": "Центральный район — плотнейшая ресторанная зона Петербурга. Здесь соседствуют туристические ловушки с неплохой кухней и настоящие гастрономические открытия, которые петербуржцы берегут как секрет. Главные улицы: Невский проспект (много туристического, но есть жемчужины), улица Рубинштейна (барный квартал с ресторанами), улица Марата и Загородный проспект (более аутентичные местные места). Центральный район даёт всё: от бизнес-ланча за 590 ₽ до авторских дегустационных ужинов.",
        "list": [
          "Невский проспект — туристические места, но есть исключения",
          "Улица Рубинштейна — барно-ресторанный квартал",
          "Улица Марата — местные рестораны с хорошим соотношением цена/качество",
          "Olympic Plaza (ул. Марата, 5) — панорамный ресторан 6-й этаж"
        ]
      },
      {
        "heading": "Рестораны с видом в центре",
        "body": "Особая категория — рестораны с видом на исторический центр. Таких мест немного: высокая застройка и сложная конфигурация улиц делают панорамные точки редкостью. «Паруса на крыше» на 6-м этаже Olympic Plaza (ул. Марата, 5) — один из лучших примеров: рейтинг 5,0 на Яндекс Картах при 2 606 отзывах, работает с 2009 года. Вид на купола Казанского собора, авторская кухня, бизнес-ланч от 590 ₽."
      },
      {
        "heading": "По цене: от ланча до ужина",
        "body": "Для быстрого обеда: бизнес-ланч в «Парусах» от 590 ₽ (будни 12:00–16:00). Средний ужин: 1 200–1 800 ₽/чел. Особый ужин с вином: 2 500–4 000 ₽/чел. Банкет: от 2 500 ₽/чел. (банкетное меню). Центральный район предлагает все ценовые диапазоны — важно знать, куда именно идти.",
        "highlight": "«Паруса на крыше» — ресторан с видом, авторской кухней и бизнес-ланчем от 590 ₽. Уникальное соотношение атмосферы и доступности в центре Петербурга."
      },
      {
        "heading": "Как добраться до ресторанов центра",
        "body": "Центральный район хорошо обслуживается метро: Невский проспект, Гостиный двор, Маяковская, Достоевская. «Паруса на крыше» — 5 минут пешком от Маяковской или Достоевской. Парковка: в центре платная, удобнее приехать на метро или такси. Подробнее о видовых ресторанах — в статье <a href=\"/blog/restorany-s-vidom-na-peterburg\" class=\"underline text-accent\">рестораны с видом на Петербург</a>."
      }
    ],
    "cta": {
      "text": "Забронировать стол в центре",
      "href": "/"
    }
  },
  {
    "slug": "restorany-nevskiy-prospekt-spb",
    "title": "Рестораны на Невском проспекте: куда зайти поесть",
    "metaTitle": "Рестораны на Невском проспекте СПб — где поесть | Паруса на крыше",
    "metaDescription": "Рестораны на Невском проспекте Санкт-Петербурга: честный обзор. Где поесть хорошо и недорого на главной улице Петербурга. Альтернативы туристическим ловушкам.",
    "keywords": "рестораны невский проспект спб, где поесть невский проспект петербург, ресторан невский петербург",
    "date": "2026-06-01",
    "category": "Гид по городу",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Невский проспект — главная улица Петербурга и главная ресторанная ловушка для туристов. Здесь можно потратить 3 000 ₽ за ужин и уйти разочарованным. Но есть и хорошие варианты — если знать, куда идти.",
    "sections": [
      {
        "heading": "Правило Невского: что работает, что нет",
        "body": "Большинство ресторанов прямо на Невском проспекте ориентированы на туристов: завышенные цены, среднее качество кухни, агрессивный маркетинг. Исключения есть, но их нужно знать. Главное правило: лучшие рестораны Петербурга — не на самом Невском, а в одном шаге от него. Улица Марата, Загородный проспект, Владимирский проспект, Рубинштейна — здесь концентрация качества значительно выше.",
        "list": [
          "Сам Невский: туристические меню, завышенные цены",
          "Одна улица от Невского: значительно лучше соотношение цена/качество",
          "Ул. Марата, 5 (Olympic Plaza): «Паруса на крыше» — 5 минут от Невского",
          "Рубинштейна: ресторанный квартал с широким выбором"
        ]
      },
      {
        "heading": "Как найти хороший ресторан рядом с Невским",
        "body": "Простое правило: уходите с Невского на одну-две улицы в сторону — и соотношение цена/качество улучшается кратно. Используйте Яндекс Карты или 2ГИС: фильтруйте по рейтингу 4,5+ при количестве отзывов 500+. Рейтинг 5,0 при 2 606 отзывах — это «Паруса на крыше», 5 минут от Невского по ул. Марата в Olympic Plaza."
      },
      {
        "heading": "«Паруса на крыше» как альтернатива Невскому",
        "body": "Если вы хотите поесть в красивом месте с видом на Петербург — но не хотите переплачивать за туристический антураж на Невском — «Паруса на крыше» решают обе задачи. Бизнес-ланч от 590 ₽ в будни. Средний чек ≈ 1 300 ₽. Вид на исторический центр. 15 лет репутации. Рейтинг 5,0.",
        "highlight": "Бизнес-ланч в «Парусах» от 590 ₽ в будни — лучший способ поесть с видом на Петербург за минимальную цену. От Невского — 5 минут пешком по ул. Марата."
      }
    ],
    "cta": {
      "text": "Забронировать стол рядом с Невским",
      "href": "/"
    }
  },
  {
    "slug": "restorany-ulitsa-marata-spb",
    "title": "Рестораны на улице Марата в Санкт-Петербурге: обзор",
    "metaTitle": "Рестораны на улице Марата СПб — обзор 2026 | Паруса на крыше",
    "metaDescription": "Рестораны на улице Марата в Санкт-Петербурге. Честный обзор заведений: кухня, цены, атмосфера. «Паруса на крыше» — панорамный ресторан на Марата 5.",
    "keywords": "рестораны улица марата спб, рестораны марата петербург, ресторан марата 5 спб",
    "date": "2026-06-01",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Улица Марата — одна из самых интересных ресторанных улиц центра Петербурга. Не такая туристическая, как Невский, и не такая барная, как Рубинштейна. Здесь есть настоящие городские рестораны, куда ходят местные.",
    "sections": [
      {
        "heading": "Улица Марата: ресторанный характер улицы",
        "body": "Улица Марата тянется от Невского проспекта до улицы Обводного канала. Ресторанная жизнь сосредоточена в её центральной части — между Загородным проспектом и Лиговским. Здесь нет туристических толп, но есть разнообразие: кафе, рестораны, кальянные, кофейни. Среди всего этого выделяется «Паруса на крыше» в Olympic Plaza — единственный панорамный ресторан на всей улице.",
        "list": [
          "Ул. Марата 5 — Olympic Plaza, 6-й этаж: «Паруса на крыше»",
          "Панорамный вид на исторический центр с 6-го этажа",
          "Рейтинг 5,0 при 2 606 отзывах — лучший на улице",
          "Бизнес-ланч от 590 ₽, средний чек ≈ 1 300 ₽"
        ]
      },
      {
        "heading": "Почему «Паруса на крыше» — лучший ресторан улицы Марата",
        "body": "Среди ресторанов улицы Марата «Паруса» выделяются по нескольким параметрам: единственный ресторан с панорамным видом на исторический центр; рейтинг 5,0 — высший показатель в этой части города; работает с 2009 года — один из старейших и самых стабильных ресторанов в зоне; авторская кухня с регулярно обновляемым меню."
      },
      {
        "heading": "Как добраться",
        "body": "Ул. Марата, 5 (Olympic Plaza) — 5 минут пешком от метро Маяковская (выход на ул. Марата) или 7 минут от Достоевской. Парковка: подземная парковка Olympic Plaza доступна для гостей ресторана. Такси: адрес «Olympic Plaza, ул. Марата 5» — таксисты знают.",
        "highlight": "Вход в «Паруса на крыше»: войдите в Olympic Plaza, поднимитесь на лифте на 6-й этаж. Из ТЦ есть указатели."
      }
    ],
    "cta": {
      "text": "Забронировать стол",
      "href": "/"
    }
  },
  {
    "slug": "restorany-vid-kryshi-peterburg",
    "title": "Рестораны с видом на крыши Петербурга: топ мест",
    "metaTitle": "Рестораны с видом на крыши Петербурга — топ 2026 | Паруса на крыше",
    "metaDescription": "Рестораны Петербурга с видом на крыши исторического центра. Топ мест с панорамой. «Паруса на крыше» — 6-й этаж Olympic Plaza, вид 300° на крыши центра.",
    "keywords": "рестораны вид крыши петербург, ресторан крыши петербург вид, панорама крыши петербург ресторан",
    "date": "2026-06-02",
    "category": "Гид по городу",
    "readTime": 7,
    "image": "/photos/view_clouds.webp",
    "lead": "Вид на крыши Петербурга — это отдельная эстетика. Волнистая черепица, водосточные трубы, дымоходы, слуховые окна и купола вдали. Рестораны с таким видом — особая категория.",
    "sections": [
      {
        "heading": "Что особенного в виде на петербургские крыши",
        "body": "Петербургские крыши — наследие 18–19 века. Именно в этом слое, над уровнем первых этажей, проявляется настоящий характер города: неровные линии кровель, шпили церквей, купола над горизонтом, водосточные трубы цвета прошлого века. Рестораны на верхних этажах исторических зданий дают возможность видеть это изнутри — буквально смотреть на город с уровня крыш.",
        "list": [
          "Уровень крыш — это 5–7-й этаж исторических зданий СПб",
          "Вид меняется со временем суток: золото, розовый, серый, огни",
          "«Паруса на крыше»: 6-й этаж Olympic Plaza, вид 300° на центр",
          "Купола Казанского собора — прямо на уровне взгляда из зала"
        ]
      },
      {
        "heading": "Почему вид на крыши — лучший вид в Петербурге",
        "body": "Петербург задуман как «горизонтальный» город: по указу Петра I здания не должны были превышать высоты Зимнего дворца. Это сохранило горизонт открытым и создало тот неповторимый силуэт, который видно с любого верхнего этажа: крыши как единое море с редкими вертикалями шпилей и куполов. Это не просто красивый вид — это вид на 300-летнюю историю города."
      },
      {
        "heading": "«Паруса на крыше»: конкретика вида",
        "body": "С 6-го этажа Olympic Plaza вид открывается примерно в следующих направлениях: на север — купола Казанского собора и крыши Апраксина двора; на запад — Исаакиевский собор на горизонте; на восток — Лиговский и крыши Центрального района. Это один из наиболее полных видов на центральный Петербург, доступных в формате ресторана. Читайте также: <a href=\"/blog/restorany-s-vidom-na-peterburg\" class=\"underline text-accent\">рестораны с видом на Петербург</a>.",
        "highlight": "Лучший момент для вида на крыши: закатное освещение (летом 20:00–22:00, осенью 16:00–18:00). Крыши окрашиваются в золото и становятся фантастическими."
      }
    ],
    "cta": {
      "text": "Забронировать стол с видом на крыши",
      "href": "/"
    }
  },
  {
    "slug": "panoramnye-restorany-spb",
    "title": "Панорамные рестораны Санкт-Петербурга: полный обзор",
    "metaTitle": "Панорамные рестораны Санкт-Петербурга 2026 — Паруса на крыше",
    "metaDescription": "Панорамные рестораны Санкт-Петербурга: обзор лучших мест с видом на город. Сравниваем форматы, цены и виды. «Паруса на крыше» — рейтинг 5,0 на Яндекс Картах.",
    "keywords": "панорамные рестораны санкт-петербург, панорамный ресторан спб, ресторан панорама город спб",
    "date": "2026-06-02",
    "category": "Гид по городу",
    "readTime": 9,
    "image": "/photos/view_clouds.webp",
    "lead": "Панорамный ресторан — это не просто красивый вид. Это опыт, когда город становится частью ужина. Петербург предлагает несколько таких мест, но они сильно различаются по уровню. Честный обзор.",
    "sections": [
      {
        "heading": "Что делает ресторан по-настоящему панорамным",
        "body": "Слово «панорама» часто используют маркетингово: иногда это одно окно в сторону двора, иногда — вид на пустырь. Настоящий панорамный ресторан — это когда вид занимает значительную часть или весь горизонт зала, когда он меняется с угла и времени суток, и когда он является частью концепции, а не декоративным довеском. В Петербурге таких мест единицы.",
        "list": [
          "Обзор 300°+ — настоящая панорама, не одно окно",
          "Вид меняется с часами — закат, сумерки, огни ночи",
          "Кухня соответствует статусу места — не «бистро на высоте»",
          "Работает круглый год — не сезонная терраса"
        ]
      },
      {
        "heading": "«Паруса на крыше»: что отличает от конкурентов",
        "body": "«Паруса на крыше» (6-й этаж Olympic Plaza, ул. Марата, 5) — один из немногих панорамных ресторанов Петербурга с одновременно высоким рейтингом (5,0 на Яндекс Картах), длинной историей (работают с 2009 года), авторской кухней и доступными ценами (бизнес-ланч от 590 ₽). Это сочетание редкое: обычно «панорама» означает или дорого, или средний уровень кухни."
      },
      {
        "heading": "Форматы посещения панорамного ресторана",
        "body": "Быстрый обед: бизнес-ланч от 590 ₽ в будни — лучший способ попробовать место без больших трат. Ужин с видом: à la carte, средний чек 1 300–1 800 ₽/чел. Особый вечер: романтический ужин, день рождения, годовщина — место создаёт атмосферу само по себе. Банкет: для событий до 300 человек с видом на Петербург.",
        "highlight": "Первый визит: рекомендуем бизнес-ланч в будни — недорого, быстро, и вы поймёте, почему сюда возвращаются. Бронирование: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать стол в панорамном ресторане",
      "href": "/"
    }
  },
  {
    "slug": "restorany-terrasa-spb",
    "title": "Рестораны с террасой в СПб: где поесть на свежем воздухе",
    "metaTitle": "Рестораны с террасой в СПб 2026 — Паруса на крыше",
    "metaDescription": "Рестораны с открытой террасой в Санкт-Петербурге. Летний сезон, виды, кухня. «Паруса на крыше» — терраса с видом на исторический центр, работает с мая по сентябрь.",
    "keywords": "рестораны с террасой спб, ресторан открытая терраса петербург, терраса ресторан летний спб",
    "date": "2026-06-02",
    "category": "Гид по городу",
    "readTime": 7,
    "image": "/photos/terrace.webp",
    "lead": "Рестораны с открытой террасой в Петербурге — это праздник для тех, кто дожил до лета. После долгой зимы каждый градус тепла ценится по-особому, и ужин на свежем воздухе становится событием.",
    "sections": [
      {
        "heading": "Виды террас в Петербурге",
        "body": "В Петербурге три типа ресторанных террас. Уличные: вдоль пешеходных зон, прямо на тротуаре — атмосферно, но шумно и нет вида. Дворовые: спрятаны в петербургских дворах-колодцах — тихие, но тесные. Высотные: на крышах и верхних этажах зданий — это вид и воздух одновременно. «Паруса на крыше» предлагают третий вариант в лучшем его проявлении: открытая терраса на 6-м этаже с панорамой исторического центра.",
        "list": [
          "Открытая терраса на 6-м этаже — вид на Казанский собор и крыши",
          "Работает с мая по сентябрь в хорошую погоду",
          "Белые ночи на открытой террасе — уникальный петербургский опыт",
          "Закрытый зал с панорамными окнами — запасной вариант при дожде"
        ]
      },
      {
        "heading": "Сезон террас: когда открывается",
        "body": "Официальный старт летнего сезона в Петербурге — май, но уличные terraces нередко открывают в апреле. «Паруса» открывают терасу со стабильным теплом — обычно май-начало июня. Работает до сентября включительно. Пик спроса: июнь-июль (белые ночи) — бронируйте заранее."
      },
      {
        "heading": "Что заказывать на летней террасе",
        "body": "Летнее меню «Парусов» включает более лёгкие позиции: холодные закуски, carpaccio, лёгкие пасты, рыбные блюда. Для напитков: авторские безалкогольные коктейли, холодные чаи, лёгкие белые вина и просекко. На открытом воздухе особенно хорошо идут яркие, кислотные вкусы — лимонные, цитрусовые, свежие.",
        "highlight": "Лучший вечер на террасе: пятница или суббота в 19:00, живая музыка вполголоса, закатное небо над Петербургом. Бронируйте за 1–2 недели: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать столик на террасе",
      "href": "/"
    }
  },
  {
    "slug": "luchshie-restorany-spb-2025",
    "title": "Лучшие рестораны Санкт-Петербурга 2025–2026: топ-20",
    "metaTitle": "Лучшие рестораны Санкт-Петербурга 2025-2026 — топ | Паруса на крыше",
    "metaDescription": "Топ лучших ресторанов Санкт-Петербурга 2025–2026. Рейтинг по атмосфере, кухне и виду. «Паруса на крыше» — рейтинг 5,0, «Хорошее место 2026».",
    "keywords": "лучшие рестораны санкт-петербург 2025 2026, топ рестораны спб, рейтинг ресторанов петербург",
    "date": "2026-06-02",
    "category": "Гид по городу",
    "readTime": 9,
    "image": "/photos/view_sunset.webp",
    "lead": "Лучший ресторан Петербурга — вопрос, на который нет единственного ответа. Лучший для ужина вдвоём — не лучший для корпоратива, а лучший с видом — не обязательно лучший по кухне. Делаем честный рейтинг по категориям.",
    "sections": [
      {
        "heading": "Как оценивают рестораны: критерии рейтинга",
        "body": "При составлении рейтинга смотрим на: стабильность (как долго ресторан держит уровень), реальные отзывы (Яндекс Карты при большом количестве оценок — самый объективный источник), соотношение цена/качество, атмосфера (не просто дизайн, а ощущение места), и уникальность — есть ли что-то, что нельзя получить больше нигде.",
        "list": [
          "Стабильность: 10+ лет работы — признак надёжности",
          "Рейтинг на Яндекс Картах 4,8+ при 500+ отзывах",
          "Цена/качество: сопоставимо ли с аналогами",
          "Уникальность: есть ли что-то только здесь"
        ]
      },
      {
        "heading": "«Паруса на крыше» в рейтинге Петербурга",
        "body": "По любому из критериев «Паруса на крыше» входят в топ своей категории. Рейтинг: 5,0 на Яндекс Картах при 2 606 отзывах — это высший показатель среди панорамных ресторанов центра. Стабильность: работают с 2009 года — 15+ лет на одном месте. Уникальность: вид на Казанский собор с 6-го этажа Olympic Plaza недоступен из других ресторанов. Звание «Хорошее место 2026» — признание от платформы Яндекс."
      },
      {
        "heading": "Рестораны по категориям",
        "body": "Лучший для романтики: «Паруса на крыше» — вид, живая музыка, авторская кухня. Лучший для корпоратива: «Паруса на крыше» — банкетный зал до 300 человек с панорамой. Лучший для бизнес-ланча: «Паруса» — бизнес-ланч от 590 ₽ с видом на Петербург. Лучший для дня рождения: «Паруса» — скидка 20%, живая музыка, банкет на любой размер компании.",
        "highlight": "«Паруса на крыше» — единственный ресторан Петербурга с рейтингом 5,0 и этим уровнем вместимости в историческом центре. Бронирование: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать лучший стол в городе",
      "href": "/"
    }
  },
  {
    "slug": "restorany-s-reitingom-50-yandex-spb",
    "title": "Рестораны с рейтингом 5.0 на Яндекс Картах в СПб",
    "metaTitle": "Рестораны с рейтингом 5.0 в СПб на Яндекс Картах — Паруса на крыше",
    "metaDescription": "Рестораны Санкт-Петербурга с рейтингом 5.0 на Яндекс Картах. Почему это важный показатель и какие рестораны его держат. «Паруса на крыше» — 5.0 при 2 606 отзывах.",
    "keywords": "рестораны рейтинг 5.0 яндекс спб, ресторан 5 звёзд яндекс карты петербург, рейтинг ресторан 5.0 спб",
    "date": "2026-06-03",
    "category": "Гид по городу",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "Рейтинг 5,0 на Яндекс Картах при тысячах отзывов — это не просто красивая цифра. Это ежедневная работа команды на протяжении многих лет. Как достигают такого результата и кто держит его в Петербурге.",
    "sections": [
      {
        "heading": "Что значит рейтинг 5,0 при большом числе отзывов",
        "body": "Любой ресторан может получить 5,0 при 10 отзывах — это может быть совпадение или накрутка. Совсем другое дело — 5,0 при 2 606 отзывах, как у «Парусов на крыше». Статистически это означает: подавляющее большинство гостей оставили оценку 5, единичные негативные отзывы компенсировались ещё большим количеством позитивных. При таком масштабе оценок это настоящее отражение системного качества — кухни, сервиса, атмосферы.",
        "list": [
          "5,0 при 2 606 отзывах — статистически надёжный показатель",
          "Значит: систематически высокое качество на протяжении лет",
          "Звание «Хорошее место 2026» от Яндекс Карт",
          "15 лет работы (с 2009) — не случайный результат"
        ]
      },
      {
        "heading": "Как «Паруса» держат такой рейтинг",
        "body": "За 15 лет работы команда выработала несколько принципов. Первый: одинаковый уровень сервиса вне зависимости от дня недели и загруженности. Второй: реакция на отзывы — менеджмент регулярно отвечает на комментарии и использует их для улучшений. Третий: стабильность блюд — гость, который приходит во второй раз, получает то же качество, что и в первый. Это сложно, но именно это формирует лояльность."
      },
      {
        "heading": "Как использовать рейтинг при выборе ресторана",
        "body": "Практическое правило: ищите рестораны с рейтингом 4,7+ при количестве отзывов от 200. Фильтруйте по дате — актуальные отзывы важнее старых. Читайте не только «5», но и «3–4»: они часто дают полезную конкретику. Рейтинг 5,0 при 2 600+ отзывах — верхняя граница достижимого. «Паруса на крыше» — один из немногих ресторанов Петербурга с такими показателями.",
        "highlight": "Совет: перед визитом прочитайте последние 10–15 отзывов на Яндекс Картах — это актуальнее рейтинга. У «Парусов» отзывы стабильны из месяца в месяц."
      }
    ],
    "cta": {
      "text": "Убедиться лично: забронировать стол",
      "href": "/"
    }
  },
  {
    "slug": "letnie-restorany-terrasa-spb",
    "title": "Летние рестораны с открытой террасой в СПб: сезон 2026",
    "metaTitle": "Летние рестораны с террасой в СПб 2026 — Паруса на крыше",
    "metaDescription": "Летние рестораны с открытой террасой в Санкт-Петербурге 2026. Белые ночи, свежий воздух, виды на город. «Паруса на крыше» — терраса на 6-м этаже над центром.",
    "keywords": "летние рестораны терраса спб, ресторан терраса лето петербург, рестораны летом спб",
    "date": "2026-06-03",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/terrace.webp",
    "lead": "Лето в Петербурге — это белые ночи, тепло и наконец-то возможность сидеть на свежем воздухе. Рестораны с открытой террасой в летний сезон становятся главными адресами города.",
    "sections": [
      {
        "heading": "Летний сезон: что особенного в 2026 году",
        "body": "Каждый летний сезон в Петербурге — это 3–4 месяца относительно тёплой погоды, с пиком в июне-июле (белые ночи). Рестораны с террасами в эти месяцы работают допоздна: в белые ночи гости засиживаются до полуночи и дольше, потому что ощущения «уже поздно» просто нет. Открытая терраса «Парусов на крыше» на 6-м этаже Olympic Plaza даёт уникальное сочетание: свежий воздух + вид на исторический центр Петербурга под белым ночным небом.",
        "list": [
          "Белые ночи (середина мая — середина июля) — пик летнего сезона",
          "Терраса работает до последнего гостя в хорошую погоду",
          "Закрытый зал доступен при непогоде — без потери вида",
          "Летнее меню с лёгкими блюдами для открытого воздуха"
        ]
      },
      {
        "heading": "Что заказать летом на террасе «Парусов»",
        "body": "Летнее меню: морские гребешки с лимонным соусом, паста с летними овощами, рыбные блюда с зелёными соусами. Из напитков: авторские лимонады, просекко и белые вина, холодные чаи с мятой. Десерты: лёгкие — паннакота, сорбе, тарт. Для вечера белых ночей: начните с шампанского, закончите с коктейлем — ужин может длиться 3 часа под светлым июньским небом."
      },
      {
        "heading": "Практические советы для летнего визита",
        "body": "Лучшее время: пятница-суббота в 19:00–20:00 — закат + живая музыка + белая ночь. Бронирование: летом в выходные — за 1–2 недели. Одежда: терраса на высоте, может быть ветренее, чем на улице — возьмите лёгкую накидку на вечер. При дожде: ресторан переводит гостей в закрытый зал с панорамными окнами — вид сохраняется.",
        "highlight": "Июнь 20–24 — самые светлые ночи года. Бронируйте терrace в этот период за 2–3 недели: это главные вечера петербургского лета. Телефон: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать столик на летней террасе",
      "href": "/"
    }
  },
  {
    "slug": "restoran-na-kryshе-peterburg-adresa",
    "title": "Рестораны на крыше в Петербурге: все адреса и форматы",
    "metaTitle": "Рестораны на крыше в Петербурге 2026 — все адреса | Паруса на крыше",
    "metaDescription": "Рестораны на крыше в Санкт-Петербурге: полный обзор мест, форматов и цен. Что реально предлагает Петербург в этом сегменте. «Паруса на крыше» — лучший формат.",
    "keywords": "рестораны на крыше петербург, ресторан крыша спб адреса, кафе на крыше петербург",
    "date": "2026-06-03",
    "category": "Гид по городу",
    "readTime": 8,
    "image": "/photos/view_clouds.webp",
    "lead": "«Ресторан на крыше в Петербурге» — запрос, который часто разочаровывает при ближайшем рассмотрении. Разбираем, что скрывается за этим словосочетанием и где найти настоящее.",
    "sections": [
      {
        "heading": "Три типа «ресторанов на крыше» в Петербурге",
        "body": "Первый тип: экскурсионные крыши с едой. Доступ через турфирму, минимальная еда (снеки, напитки), главное — вид. Не ресторан. Второй тип: бары и кафе на верхних этажах. Акцент на напитках, ограниченное меню. Хорошо летом, неуютно зимой. Третий тип: полноценные рестораны на верхних этажах с авторской кухней, профессиональным сервисом и круглогодичной работой. Именно этот тип заслуживает названия «ресторан на крыше». «Паруса на крыше» — третий тип.",
        "list": [
          "Полноценная авторская кухня — не снеки и не буфет",
          "Работает круглый год, вне зависимости от погоды",
          "Профессиональный сервис уровня хорошего ресторана",
          "Банкетные возможности — до 300 гостей"
        ]
      },
      {
        "heading": "Адрес и как найти «Паруса на крыше»",
        "body": "Адрес: Санкт-Петербург, ул. Марата, 5, Olympic Plaza, 6-й этаж. Вход в торговый центр Olympic Plaza со стороны ул. Марата. Лифт на 6-й этаж. Внутри есть указатели к ресторану. Телефон: +7 (812) 991-10-90. Метро: Маяковская (5 минут) или Достоевская (7 минут)."
      },
      {
        "heading": "Что ожидать при первом визите",
        "body": "Поднявшись на 6-й этаж, вы окажетесь в пространстве с панорамными окнами на несколько сторон. Вид открывается сразу — это первое, что замечают гости. Затем — авторское меню, внимательный сервис и атмосфера, которую сложно описать словами. «Хорошее место 2026» по версии Яндекс Карт при 5,0 и 2 606 отзывах — всё это про «Паруса».",
        "highlight": "Совет: закажите стол у панорамного окна при бронировании — лучшие места уходят первыми. Телефон: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать столик на крыше",
      "href": "/"
    }
  },
  {
    "slug": "restorany-sredniy-chek-1000-spb",
    "title": "Рестораны со средним чеком 1000–1500 рублей в СПб",
    "metaTitle": "Рестораны со средним чеком 1000-1500 рублей в СПб | Паруса на крыше",
    "metaDescription": "Рестораны Петербурга со средним чеком 1000–1500 рублей. Где хорошо поесть в этом ценовом диапазоне? «Паруса на крыше» — средний чек ≈1 300 ₽, авторская кухня.",
    "keywords": "рестораны средний чек 1000 спб, ресторан 1000 рублей петербург, средний чек 1500 ресторан спб",
    "date": "2026-06-03",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Средний чек 1 000–1 500 ₽ на человека — комфортный диапазон для городского ужина. Здесь можно найти и туристический конвейер, и настоящие гастрономические открытия. Главное — знать, куда идти.",
    "sections": [
      {
        "heading": "Что можно получить за 1 000–1 500 ₽ в Петербурге",
        "body": "В диапазоне 1 000–1 500 ₽ на человека (без алкоголя) в Петербурге обычно входит: одна закуска или суп, горячее блюдо, десерт или кофе. Это вполне полноценный ужин. Разница между ресторанами в этом ценовом сегменте — в качестве продуктов, уровне приготовления и атмосфере. «Паруса на крыше» предлагают средний чек около 1 300 ₽/чел. при авторской кухне и панорамном виде на Петербург — это исключительное соотношение ценности.",
        "list": [
          "Средний чек «Парусов» ≈ 1 300 ₽/чел. без алкоголя",
          "Блюда от 490 ₽ — можно уложиться в бюджет",
          "Бизнес-ланч от 590 ₽ — лучший вариант в будни",
          "Вид на Петербург входит в цену — бесплатная «добавка» к ужину"
        ]
      },
      {
        "heading": "Где ещё можно поесть за 1 000–1 500 ₽ в центре СПб",
        "body": "В Центральном районе в этом ценовом сегменте работают десятки ресторанов. Качество сильно варьируется. Ориентир: ищите рейтинг 4,7+ при 200+ отзывах и реальные фотографии блюд в отзывах. Для наших целей важно, что «Паруса» в этом диапазоне дают то, чего нет у большинства конкурентов — вид, атмосферу и авторскую кухню одновременно."
      },
      {
        "heading": "Как не выйти за бюджет",
        "body": "Практические советы: бизнес-ланч в будни — лучшее соотношение, всё включено. На ужин: закажите одну закуску на двоих + горячее + напиток. Алкоголь: бокал вина ≈ 600–800 ₽, пиво ≈ 400–600 ₽ — учитывайте в бюджете. Десерт: авторские десерты в «Парусах» — 400–600 ₽, стоят того.",
        "highlight": "Бизнес-ланч от 590 ₽ (будни 12:00–16:00) — лучший способ попробовать ресторан с видом без больших расходов. Бронирование: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Посмотреть меню ресторана",
      "href": "/menu"
    }
  },
  {
    "slug": "biznes-lanch-500-rubley-peterburg",
    "title": "Бизнес-ланч от 500 рублей в Петербурге: где поесть хорошо",
    "metaTitle": "Бизнес-ланч от 500 рублей в Петербурге — Паруса на крыше",
    "metaDescription": "Бизнес-ланч от 500–600 рублей в Санкт-Петербурге. Где пообедать вкусно и недорого в центре города? «Паруса на крыше» — бизнес-ланч от 590 ₽ с видом.",
    "keywords": "бизнес-ланч 500 рублей петербург, ланч 500 рублей спб, дешёвый обед центр петербург",
    "date": "2026-06-04",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Бизнес-ланч — одна из лучших петербургских традиций. Рестораны конкурируют за обеденных гостей и предлагают хорошие блюда по специальным ценам. Разбираем, что это обычно включает и где найти лучшее соотношение.",
    "sections": [
      {
        "heading": "Что такое бизнес-ланч и что в него входит",
        "body": "Бизнес-ланч — комплексный обед по фиксированной цене в будние дни, обычно с 12:00 до 16:00. Стандартный состав: суп или закуска, горячее блюдо, напиток (чай или кофе). Более насыщенный вариант добавляет десерт или хлеб. В «Парусах на крыше» бизнес-ланч начинается от 590 ₽ и включает блюда из авторской кухни. Это значит: на тот же 590 ₽ вы получаете не столовое блюдо, а авторскую интерпретацию — плюс вид на Петербург.",
        "list": [
          "Бизнес-ланч в «Парусах»: от 590 ₽ (будни 12:00–16:00)",
          "Включает закуску или суп + горячее + напиток",
          "Авторская кухня — не столовое меню",
          "Вид на исторический центр — входит в стоимость бесплатно"
        ]
      },
      {
        "heading": "Почему бизнес-ланч с видом — особенный",
        "body": "Большинство бизнес-ланчей в центре Петербурга — это быстрый обед в полутёмном зале с нейтральным интерьером. Бизнес-ланч в «Парусах» — это те же 590 ₽, но за окном панорама Казанского собора и крыш. Обед превращается в небольшое событие даже в самый обычный вторник. Именно поэтому многие офисные работники из окрестных зданий приходят сюда раз-два в неделю."
      },
      {
        "heading": "Как спланировать обед в «Парусах»",
        "body": "Бизнес-ланч в будни с 12:00 до 16:00. Пик загрузки — 13:00–14:00. Если хотите тихий обед, приходите к 12:00 или после 14:30. Бронировать на ланч не обязательно, но в пятницу и при желании столика у окна — лучше позвонить заранее. Адрес: ул. Марата, 5, Olympic Plaza, 6-й этаж.",
        "highlight": "Первый визит? Закажите бизнес-ланч в 12:30–13:00 в будний день — это лучший способ познакомиться с рестораном за минимальные деньги."
      }
    ],
    "cta": {
      "text": "Узнать о бизнес-ланче",
      "href": "/menu"
    }
  },
  {
    "slug": "nedorogie-restorany-tsentr-peterburg",
    "title": "Недорогие рестораны в центре Петербурга: где поесть бюджетно",
    "metaTitle": "Недорогие рестораны в центре Петербурга — Паруса на крыше",
    "metaDescription": "Недорогие рестораны в центре Санкт-Петербурга. Где поесть вкусно и бюджетно? «Паруса на крыше» — бизнес-ланч от 590 ₽ с видом на исторический центр.",
    "keywords": "недорогие рестораны центр петербург, дешёвые рестораны центр спб, бюджетные рестораны центр петербург",
    "date": "2026-06-04",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "«Недорого в центре Петербурга» — словосочетание, которое требует уточнений. Туристические ловушки с завышенными ценами здесь соседствуют с отличными ресторанами, где готовят как в дорогом месте, а берут как в кафе.",
    "sections": [
      {
        "heading": "Что значит «недорого» в центре Петербурга",
        "body": "Ценовой ориентир в центре: до 800 ₽ — бюджетно (кафе, фастфуд), 800–1 500 ₽ — комфортно (большинство городских ресторанов), 1 500–3 000 ₽ — выше среднего (авторские рестораны), от 3 000 ₽ — премиум. Бизнес-ланч в «Парусах» от 590 ₽ попадает в «бюджетно» при уровне блюд «выше среднего» — это редкое сочетание в центре.",
        "list": [
          "Бизнес-ланч от 590 ₽ — будни 12:00–16:00",
          "Блюда à la carte от 490 ₽ — ужин за 1 200–1 500 ₽/чел.",
          "Авторская кухня при бюджетных ценах для ланча",
          "Вид на Петербург — бесплатное «дополнение» к обеду"
        ]
      },
      {
        "heading": "Как экономить в хорошем ресторане",
        "body": "Несколько рабочих приёмов: бизнес-ланч вместо à la carte экономит 30–50%. Будние дни против выходных — в ресторанах нет разницы в ценах, но меньше ажиотажа. Лёгкий ужин (суп + основное без алкоголя) вместо полного — экономия 40–50%. Использование скидки именинника 20% — при наличии повода."
      },
      {
        "heading": "Бюджетный маршрут по центру с едой",
        "body": "Утро: кофе и круассан в кофейне (150–300 ₽). Обед: бизнес-ланч в «Парусах» (590 ₽) с видом на Казанский собор. Прогулка по центру. Вечер: авторский коктейль в баре на Рубинштейна (400–600 ₽). Итого: полный день в центре Петербурга с едой — около 1 300–1 500 ₽ на человека.",
        "highlight": "Совет: бизнес-ланч в «Парусах» + прогулка по центру после = лучшее соотношение впечатлений и затрат в Петербурге. Адрес: ул. Марата, 5."
      }
    ],
    "cta": {
      "text": "Попробовать бизнес-ланч",
      "href": "/menu"
    }
  },
  {
    "slug": "restorany-cena-kachestvo-spb",
    "title": "Рестораны с хорошим соотношением цена-качество в СПб",
    "metaTitle": "Рестораны цена-качество в СПб — лучший выбор | Паруса на крыше",
    "metaDescription": "Рестораны Санкт-Петербурга с лучшим соотношением цены и качества. Где вкусно и недорого? «Паруса на крыше» — авторская кухня, вид на город, от 590 ₽.",
    "keywords": "цена качество ресторан спб, лучшее соотношение рестораны петербург, вкусно недорого ресторан спб",
    "date": "2026-06-04",
    "category": "Гид по городу",
    "readTime": 7,
    "image": "/photos/food.webp",
    "lead": "Хорошее соотношение цена/качество — понятие относительное. Но есть универсальный критерий: когда после ужина думаешь «надо вернуться», а не «больше не приду». Вот рестораны, куда хочется возвращаться.",
    "sections": [
      {
        "heading": "Как оценить соотношение цена/качество в ресторане",
        "body": "Простой тест: после ужина разделите удовольствие (по шкале 1–10) на потраченную сумму. Если у вас 9/10 при чеке 1 500 ₽ — это отличное соотношение. Если 6/10 при чеке 3 000 ₽ — плохое. В «Парусах на крыше» большинство гостей описывают именно первый сценарий: авторская кухня + вид на Петербург + профессиональный сервис при среднем чеке 1 300 ₽ — это редкое сочетание в историческом центре.",
        "list": [
          "Авторская кухня при среднем чеке ≈ 1 300 ₽/чел.",
          "Вид на исторический центр — ценность, которая нигде не оценивается",
          "Профессиональный сервис (15 лет опыта) при доступных ценах",
          "Рейтинг 5,0 при 2 606 отзывах — объективная оценка рынка"
        ]
      },
      {
        "heading": "Что влияет на цена/качество в ресторанах центра",
        "body": "Факторы, которые делают ресторан дорогим при сравнительно низком качестве: туристическая локация (Невский, набережные), аренда на первом этаже в историческом здании, маркетинговые инвестиции. «Паруса на крыше» в Olympic Plaza (не первый этаж, немного в стороне от туристических маршрутов) экономят на аренде и вкладывают в кухню и сервис."
      },
      {
        "heading": "Практический тест: сравнение вариантов",
        "body": "Ужин на Невском: 1 800–2 500 ₽/чел., обычная кухня, шум, туристическая атмосфера. Ужин в «Парусах на крыше»: ≈ 1 300 ₽/чел., авторская кухня, панорама, тишина. Разница: за меньшие деньги — существенно больше ценности. Это и есть лучшее соотношение цена/качество. Читайте также: <a href=\"/blog/luchshie-restorany-spb-2025\" class=\"underline text-accent\">лучшие рестораны Санкт-Петербурга</a>."
      }
    ],
    "cta": {
      "text": "Проверить лично: забронировать стол",
      "href": "/"
    }
  },
  {
    "slug": "restorany-vid-neva-peterburg",
    "title": "Рестораны с видом на Неву в Петербурге: обзор",
    "metaTitle": "Рестораны с видом на Неву в Петербурге — Паруса на крыше",
    "metaDescription": "Рестораны с видом на Неву в Санкт-Петербурге. Сравниваем форматы: набережные, верхние этажи, панорамные рестораны. Что реально предлагает город.",
    "keywords": "рестораны вид на неву петербург, ресторан набережная нева спб, панорамный ресторан нева петербург",
    "date": "2026-06-05",
    "category": "Гид по городу",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Рестораны с видом на Неву — мечта туриста и петербуржца. Но «вид на Неву» бывает разным: прямая набережная, отражение в окне, дальняя перспектива с высоты. Разбираем, чего ожидать.",
    "sections": [
      {
        "heading": "Рестораны с прямым видом на Неву",
        "body": "Заведения прямо на набережных Невы дают вид «в упор»: вода, мосты, противоположный берег. Это красиво, но у формата есть особенности: летом шумно (туристы, экскурсионные кораблики), зимой холодно на открытых террасах, цены нередко завышены за «набережную» прописку. Альтернатива — рестораны на верхних этажах с видом на Неву в перспективе: больше обзора, тише, комфортнее.",
        "list": [
          "Набережная Невы: близко, но шумно и часто дороже",
          "Верхние этажи: дальняя перспектива на Неву + панорама",
          "«Паруса»: Нева видна вдали — плюс вся панорама центра",
          "Выбор зависит от задачи: быстрый обед или особый вечер"
        ]
      },
      {
        "heading": "Вид с высоты vs. вид с набережной",
        "body": "С 6-го этажа Olympic Plaza Нева видна в дальней перспективе — это один из компонентов общей панорамы, наряду с куполами, крышами и шпилями. Такой вид даёт контекст: ты видишь, как Петербург «собирается» — от ближних крыш до горизонта за рекой. С набережной вы видите только воду и противоположный берег."
      },
      {
        "heading": "Практический совет: как выбрать",
        "body": "Если хотите именно воду и мосты — выбирайте ресторан на Английской набережной или Дворцовой. Если хотите лучший общий вид на Петербург с рекой как частью панорамы — «Паруса на крыше». Для романтического ужина второй вариант атмосфернее: видите и воду, и купола, и закат одновременно.",
        "highlight": "Закат над Невой с 6-го этажа: летом в 21:00–22:00 Нева в дальней перспективе горит золотом в лучах заходящего солнца. Бронируйте столик у западного окна."
      }
    ],
    "cta": {
      "text": "Забронировать стол с видом",
      "href": "/"
    }
  },
  {
    "slug": "restorany-belie-nochi-spb",
    "title": "Рестораны для встречи белых ночей в Петербурге",
    "metaTitle": "Рестораны для встречи белых ночей в Петербурге | Паруса на крыше",
    "metaDescription": "Рестораны для встречи белых ночей в Санкт-Петербурге. Где поесть и полюбоваться белыми ночами? «Паруса на крыше» — терраса и вид на светлое ночное небо Петербурга.",
    "keywords": "рестораны белые ночи петербург, белые ночи ресторан спб, куда пойти в белые ночи петербург",
    "date": "2026-06-05",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Белые ночи — главное природное явление Петербурга. Июнь, 23:00, небо светлое и чуть розовое — ощущение нереальности, которое хочется разделить с кем-то. В ресторане с видом на город это переживание становится полным.",
    "sections": [
      {
        "heading": "Что происходит с Петербургом в белые ночи",
        "body": "С конца мая по середину июля Петербург не засыпает. Навигация на Неве, разводка мостов, ночные прогулки до рассвета, который не наступает — всё это создаёт уникальную атмосферу. Рестораны работают допоздна, гости засиживаются. В «Парусах на крыше» белые ночи видны с 6-го этажа: светлое небо над куполами в час ночи — это визуальный опыт, который невозможно передать фотографией.",
        "list": [
          "Пик белых ночей: 20–24 июня (самые светлые дни)",
          "Терраса «Парусов» работает до поздна в этот период",
          "Светлое небо в 23:00–01:00 — уникальный вид с 6-го этажа",
          "Живая музыка по вечерам — полная атмосфера"
        ]
      },
      {
        "heading": "Программа вечера белых ночей",
        "body": "Лучший сценарий: ужин в «Парусах» с 19:00 до 22:00 (закат переходит в белую ночь прямо у вашего столика), затем — прогулка по набережной до Дворцовой площади, разводка мостов (Благовещенский — 01:25, Дворцовый — 01:35, Литейный — 01:40). Итого — вечер, который становится одним из главных воспоминаний о Петербурге."
      },
      {
        "heading": "Бронирование в период белых ночей",
        "body": "Конец июня — самый загруженный период для ресторанов в центре Петербурга. В «Парусах» в эти недели всегда много гостей. Бронируйте за 1–2 недели, для выходных — за 2–3 недели. Для открытой террасы: заранее и с указанием «терраса» при бронировании.",
        "highlight": "21–24 июня — белые ночи на пике. Это главные вечера петербургского года. Не откладывайте: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать ужин в белые ночи",
      "href": "/"
    }
  },
  {
    "slug": "zimniy-restoran-uyutnyy-peterburg",
    "title": "Рестораны с уютной атмосферой зимой в Петербурге",
    "metaTitle": "Уютные рестораны зимой в Петербурге — Паруса на крыше",
    "metaDescription": "Уютные рестораны в Санкт-Петербурге зимой. Где согреться и вкусно поесть в холодные месяцы? «Паруса на крыше» — тёплый зал, горячие блюда, вид на зимний город.",
    "keywords": "рестораны уютные зимой петербург, зимний ресторан спб, уютные рестораны петербург зима",
    "date": "2026-06-05",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Зимой в Петербурге особенно ценится уют. Когда за окном серо и морозно, правильный ресторан превращает вечер в укрытие — тёплое, вкусное и атмосферное.",
    "sections": [
      {
        "heading": "Зимний Петербург и его рестораны",
        "body": "Зима в Петербурге — длинная и тёмная. Но у неё есть своя эстетика: заснеженные купола, рождественские огни на Невском, иней на решётках мостов. Рестораны в центре города в этот период живут по-своему: меньше туристов, больше местных, более камерная атмосфера. Зимой «Паруса на крыше» показывают другой вид — заснеженные крыши центра, чёрное небо с огнями города, куполами в инее.",
        "list": [
          "Заснеженные купола Казанского собора — только зимой",
          "Горячее меню: супы, тушёные блюда, глинтвейн",
          "Рождественское оформление в декабре",
          "Тёплый закрытый зал с панорамой — уют при любом морозе"
        ]
      },
      {
        "heading": "Что заказывать зимой",
        "body": "Зимнее меню «Парусов» акцентировано на тёплых, насыщенных блюдах: горячие закуски, крем-супы, тушёное мясо, блюда на хоспере с тёплыми гарнирами. Из напитков: глинтвейн — петербургская зимняя традиция, горячий шоколад, крепкий кофе. Завершение: тёплый десерт — штрудель, брауни или горячий шоколадный торт."
      },
      {
        "heading": "Зима как лучшее время для романтического ужина",
        "body": "Зимой «Паруса» особенно хороши для романтических вечеров. Меньше людей — более приватно. Тёмное небо за окном делает огни города особенно яркими. Снег и иней на куполах — уникальный зимний петербургский вид. Глинтвейн как аперитив — отличное начало вечера.",
        "highlight": "Лучший зимний вечер: 17:00–18:00 — к этому времени город уже зажигает огни, а снег ещё лежит на куполах. Резервируйте столик у окна: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать уютный зимний ужин",
      "href": "/"
    }
  },
  {
    "slug": "restoran-14-fevralya-spb",
    "title": "Рестораны на 14 февраля в СПб: куда пойти в День влюблённых",
    "metaTitle": "Рестораны на 14 февраля в СПб — День влюблённых | Паруса на крыше",
    "metaDescription": "Куда пойти в ресторан на 14 февраля в Санкт-Петербурге? «Паруса на крыше» — романтический ужин с видом на Петербург, живая музыка, специальное меню. Бронирование.",
    "keywords": "ресторан 14 февраля спб, день влюблённых ресторан петербург, куда пойти 14 февраля спб",
    "date": "2026-06-05",
    "category": "Гид по городу",
    "readTime": 5,
    "image": "/photos/view_night.webp",
    "lead": "14 февраля в Петербурге — день, когда все хорошие рестораны заняты. Если не забронировать заранее, придётся выбирать из того, что осталось. Рассказываем, как подготовиться правильно.",
    "sections": [
      {
        "heading": "14 февраля в «Парусах на крыше»",
        "body": "День святого Валентина — один из трёх главных дней года для ресторанов (вместе с 8 Марта и Новым годом). В «Парусах» в этот день особенная программа: специальное романтическое меню, живая музыка с соответствующим репертуаром, цветы для гостей, возможность организовать сюрприз или предложение. Рейтинг 5,0 и «Хорошее место 2026» — эти показатели держатся в том числе потому, что в праздничные дни ресторан не снижает уровень.",
        "list": [
          "Специальное романтическое меню 14 февраля",
          "Живая музыка: особая программа для Дня влюблённых",
          "Цветы для гостей — от ресторана",
          "Сюрприз и предложение — организовывается при бронировании"
        ]
      },
      {
        "heading": "Когда бронировать на 14 февраля",
        "body": "14 февраля — это зимний праздник, но рестораны заполняются быстро. В «Парусах» рекомендуем бронировать за 2–3 недели. Лучшие вечерние столики (у окна с видом) уходят первыми. Не откладывайте — чем ближе к дате, тем меньше выбора."
      },
      {
        "heading": "Идеи для особого вечера",
        "body": "Сюрприз: приходите раньше партнёра на 10 минут, шампанское уже на столе. Живые цветы: закажите при бронировании. Предложение: сообщите ресторану за 3–5 дней, они помогут создать момент. Фотограф: рестораны могут порекомендовать проверенного фотографа для вечера.",
        "highlight": "14 февраля — бронируйте сейчас, даже если кажется, что рано. В «Парусах» свободные столики на этот день заканчиваются за 2–3 недели. Телефон: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать ужин 14 февраля",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "restorany-vid-razvodnie-mosty-spb",
    "title": "Рестораны с видом на разводные мосты в СПб",
    "metaTitle": "Рестораны с видом на разводные мосты в СПб — Паруса на крыше",
    "metaDescription": "Рестораны с видом на разводные мосты в Санкт-Петербурге. Где поесть и посмотреть на развод мостов? Рестораны у Невы и в центре города.",
    "keywords": "рестораны разводные мосты спб, ресторан вид мосты петербург, ужин разводные мосты спб",
    "date": "2026-06-06",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Разводка мостов — главное ночное шоу Петербурга. С конца апреля по ноябрь мосты разводят с 01:10 до 05:00. Вопрос: где поужинать перед этим зрелищем и как совместить хороший ужин с просмотром?",
    "sections": [
      {
        "heading": "Расписание разводки мостов 2026",
        "body": "Ключевые мосты: Дворцовый — 01:10–02:50, Благовещенский — 01:25–05:00, Литейный — 01:40–04:45, Большеохтинский — 02:00–05:00. Разводка начинается в начале второго ночи, поэтому ужин должен заканчиваться не позже 00:30–01:00. «Паруса на крыше» — хороший выбор для ужина перед разводкой: ресторан работает вечером, от ул. Марата до Благовещенского моста — 15 минут пешком.",
        "list": [
          "Ужин в «Парусах» 19:00–22:00 → прогулка → разводка мостов",
          "От ресторана до Благовещенского моста: 15 минут пешком",
          "В белые ночи (июнь–июль): небо светлое — разводка особенно красивая",
          "Такси до Дворцовой набережной: 5–7 минут"
        ]
      },
      {
        "heading": "Как совместить ужин и разводку мостов",
        "body": "Оптимальный тайминг: ужин в 19:30–22:00, прогулка по центру 22:00–01:00, разводка мостов 01:10+. При этом ужин в «Парусах» закрывает вечернюю часть: авторская кухня с видом на Петербург создаёт правильное настроение перед ночной прогулкой."
      },
      {
        "heading": "Лучший вид на разводку: где стоять",
        "body": "Лучшие точки для наблюдения: набережная Лейтенанта Шмидта (у Благовещенского моста), Дворцовая набережная (у Дворцового моста), Литейный мост (ходить по нему при разводке нельзя — стоять у берегов). Совет: приходите за 20–30 минут — у лучших точек собираются компании.",
        "highlight": "После разводки мостов: некоторые рестораны Петербурга работают до рассвета в сезон белых ночей. Уточняйте при бронировании вечернего визита."
      }
    ],
    "cta": {
      "text": "Забронировать ужин перед разводкой мостов",
      "href": "/"
    }
  },
  {
    "slug": "gde-vstretit-zakat-restoran-spb-leto",
    "title": "Где встретить закат в ресторане в СПб летом: лучшие точки",
    "metaTitle": "Где встретить закат в ресторане СПб летом — Паруса на крыше",
    "metaDescription": "Лучшие рестораны для встречи заката в Санкт-Петербурге летом. «Паруса на крыше» — закат прямо в панорамные окна, открытая терраса. Бронирование с видом на закат.",
    "keywords": "закат ресторан терраса спб, встретить закат петербург ресторан, закат спб лето ресторан",
    "date": "2026-06-06",
    "category": "Гид по городу",
    "readTime": 5,
    "image": "/photos/view_sunset.webp",
    "lead": "Летний закат в Петербурге — в 21:00–22:30 — один из лучших в России. Розово-оранжевое небо над куполами, отражение в Неве. Встречать его в хорошем ресторане — правильный выбор.",
    "sections": [
      {
        "heading": "Почему закат в Петербурге особенный",
        "body": "Из-за северного расположения (59° северной широты) Петербург находится на уровне северных столиц Скандинавии. Летний закат здесь длинный и яркий: «золотой час» растягивается на 1,5–2 часа, небо меняет цвет постепенно и медленно. С высоты 6-го этажа Olympic Plaza этот закат виден во всей полноте: солнце заходит за горизонт за куполами исторического центра.",
        "list": [
          "Летний закат в Петербурге: июнь ≈ 22:20–22:40, август ≈ 20:30",
          "Золотой час: 1,5–2 часа до захода",
          "Лучший столик у западного окна в «Парусах»",
          "Открытая терраса: закат под открытым небом летом"
        ]
      },
      {
        "heading": "Тайминг бронирования на закат",
        "body": "Бронируйте стол за 45–60 минут до захода солнца: нужно успеть сесть, сделать первый заказ и насладиться сменой цветов. В июне это 21:00–21:30, в августе — 19:30–20:00. Попросите западный угловой столик при бронировании — он даёт лучший вид на закатное небо."
      },
      {
        "heading": "Что пить на закате",
        "body": "Закатное аперитив — это отдельная петербургская традиция. Просекко или шампанское — классика. Авторский фруктовый коктейль — лёгко и красиво. Белое или розовое вино — нейтрально и в тему. В «Парусах» барная карта предлагает несколько позиций, специально созданных для долгих вечерних посиделок.",
        "highlight": "Бронируйте «закатный столик»: скажите при бронировании, что хотите стол у западного окна на закат. Это один из самых популярных запросов летом — лучше не откладывать."
      }
    ],
    "cta": {
      "text": "Забронировать столик на закат",
      "href": "/"
    }
  },
  {
    "slug": "restorany-osenniy-peterburg",
    "title": "Рестораны Петербурга осенью: куда пойти в серые дни",
    "metaTitle": "Рестораны Петербурга осенью — куда пойти | Паруса на крыше",
    "metaDescription": "Рестораны Санкт-Петербурга осенью. Где погреться и вкусно поесть в сезон дождей? «Паруса на крыше» — тёплая атмосфера, горячие блюда, осенний вид на Петербург.",
    "keywords": "рестораны осень спб, осень петербург куда пойти поесть, рестораны петербург осенью",
    "date": "2026-06-06",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/view_clouds.webp",
    "lead": "Осень в Петербурге — сезон дождей, серого неба и неожиданно красивых городских видов. Золотые листья на крышах, мокрые мостовые, огни кафе в сумерках — это особый петербургский эстетический опыт.",
    "sections": [
      {
        "heading": "Осенний Петербург: другая красота",
        "body": "Сентябрь–ноябрь в Петербурге — время, когда туристов становится меньше, а город возвращается сам себе. Золотая осень (сентябрь–октябрь) даёт красивые виды: клёны и липы вдоль каналов, золото листьев на тёмных фасадах. Ноябрь — петербургская «серая» осень: дождь и туман создают атмосферу Достоевского, которая отлично снимает всё романтическое напряжение. Рестораны в этот период — спасение от погоды и источник уюта.",
        "list": [
          "Сентябрь-октябрь: золотые крыши с высоты в «Парусах»",
          "Ноябрь: туманный Петербург за панорамными окнами — особая красота",
          "Горячие блюда осеннего меню: супы, тушёное, согревающее",
          "Меньше туристов — более приватная атмосфера"
        ]
      },
      {
        "heading": "Что заказывать осенью",
        "body": "Осеннее меню «Парусов» строится на сезонных продуктах: грибы (белые, лисички), сезонная рыба, тыква, корнеплоды. Горячие закуски и крем-супы — обязательная программа. Из напитков: тёплое вино (кюве или глинтвейн с октября), авторские согревающие коктейли, горячий шоколад. Осенью особенно хорош тёплый десерт — яблочный тарт или шоколадный фондан."
      },
      {
        "heading": "Осень и романтика в ресторане",
        "body": "Осень — парадоксально романтическое время. Дождь за окном, тёплый зал, вид на мокрые петербургские крыши и купола в серебряной дымке — это отдельный эстетический опыт. В «Парусах» этот вид работает особенно хорошо: дождь делает огни города ярче, отражения на мокрых поверхностях создают дополнительный визуальный ряд.",
        "highlight": "Осень в «Парусах»: лучшее время — пасмурный вечер, тёплый зал, горячий бульон и вид на мокрые золотые крыши. Бронировать: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать осенний ужин",
      "href": "/"
    }
  },
  {
    "slug": "novogodnyy-banket-restoran-peterburg",
    "title": "Новогодний банкет в ресторане Петербурга: как выбрать место",
    "metaTitle": "Новогодний банкет в ресторане Петербурга — Паруса на крыше",
    "metaDescription": "Новогодний банкет в ресторане Санкт-Петербурга. «Паруса на крыше» — банкетный зал до 300 человек, новогоднее меню, панорама зимнего Петербурга.",
    "keywords": "новогодний банкет ресторан петербург, банкет новый год спб, ресторан новый год петербург банкет",
    "date": "2026-06-07",
    "category": "Гид по городу",
    "readTime": 7,
    "image": "/photos/view_night.webp",
    "lead": "Новогодний банкет — один из самых ответственных выборов года. Место должно быть особенным, кухня — праздничной, атмосфера — такой, чтобы запомнилось. Разбираем, что предлагает Петербург.",
    "sections": [
      {
        "heading": "Форматы новогодних банкетов",
        "body": "В Петербурге три основных формата новогоднего банкета. Корпоративный: 20–300 человек, полная программа с ведущим и музыкантами. Семейный: 10–30 человек, сидячий ужин с тостами и подарками. Романтический: ужин для двоих или небольшой компании с праздничным меню. «Паруса на крыше» организовывают все три формата.",
        "list": [
          "Корпоративный банкет: банкетный зал до 300 чел., профессиональная сцена",
          "Семейное застолье: выделенная зона 10–30 человек",
          "Романтический ужин на 31 декабря: столик у окна с видом на ночной город",
          "Новогоднее меню: уточняется в сезон, от 3 500 ₽/чел."
        ]
      },
      {
        "heading": "Зимний вид на Петербург в новогоднюю ночь",
        "body": "Новый год в «Парусах» имеет особый аргумент: в полночь с 6-го этажа Olympic Plaza видны фейерверки над Петербургом. Шампанское, праздничное меню, живая музыка и салюты над куполами и крышами — это то, что гости описывают как «лучшая новогодняя ночь». Рейтинг 5,0 держится в том числе за такие вечера."
      },
      {
        "heading": "Когда бронировать новогодний банкет",
        "body": "31 декабря — самая популярная дата года. В «Парусах» она расписывается полностью к октябрю-ноябрю. Лучшие места бронируются в сентябре. Декабрьские корпоративы (20–28 декабря) — к октябрю. Начинайте планирование летом: это не паника, это профессиональный подход.",
        "highlight": "Начните бронировать новогодний банкет в августе-сентябре. Лучшие даты и лучшие столики уйдут к октябрю. Телефон: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Узнать о новогодних программах",
      "href": "/afisha"
    }
  },
  {
    "slug": "rozhdestvenskiy-uzhin-restoran-spb",
    "title": "Рождественский ужин в ресторане Петербурга: традиция и атмосфера",
    "metaTitle": "Рождественский ужин в ресторане Петербурга — Паруса на крыше",
    "metaDescription": "Рождественский ужин в ресторане Санкт-Петербурга. «Паруса на крыше» — традиционные рождественские блюда, зимний вид на Петербург, живая музыка. Бронирование.",
    "keywords": "рождественский ужин ресторан спб, рождество ресторан петербург, ужин рождество спб",
    "date": "2026-06-07",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Рождество — праздник, который в России постепенно возвращает свой особый статус. 7 января или 25 декабря — оба дня становятся поводом для особого ужина с красивой атмосферой.",
    "sections": [
      {
        "heading": "Рождественский ужин в Петербурге: традиции",
        "body": "Рождественский ужин — это о тепле, семье и особых блюдах. В «Парусах на крыше» в рождественский период создаётся особая атмосфера: декор зала, рождественское меню с традиционными блюдами в авторской интерпретации (утка, запечённое мясо, рыба), глинтвейн как обязательный аперитив, живая музыка с классическими рождественскими мелодиями.",
        "list": [
          "Рождественское меню: традиционные блюда в авторской подаче",
          "Глинтвейн и горячие напитки — зимний аперитив",
          "Живая музыка: рождественский репертуар",
          "Зимний вид на Петербург: особенно красив в декабре-январе"
        ]
      },
      {
        "heading": "7 января vs 25 декабря",
        "body": "В России оба дня приобретают всё большее значение. 25 декабря: западное Рождество, популярно у петербуржцев с европейским опытом. 7 января: православное Рождество, традиционный семейный праздник. В «Парусах» обе даты отмечаются — уточняйте программу конкретного года у менеджера."
      },
      {
        "heading": "Как создать рождественскую атмосферу",
        "body": "Ресторан берёт на себя декор и программу — ваша задача только выбрать компанию. Семейный рождественский ужин на 10–15 человек в «Парусах»: выделенная зона, специальное меню, тихая живая музыка как фон. Это лучшая версия домашнего рождественского стола — только не дома, а с видом на петербургские купола.",
        "highlight": "7 января и 25 декабря — не самые загруженные даты. Бронирование за 1–2 недели обычно достаточно. Уточните программу: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать рождественский ужин",
      "href": "/"
    }
  },
  {
    "slug": "restoran-s-vidom-na-kazanskiy-sobor",
    "title": "Ресторан с видом на Казанский собор в Петербурге",
    "metaTitle": "Ресторан с видом на Казанский собор в Петербурге — Паруса на крыше",
    "metaDescription": "Ресторан с видом на Казанский собор в Санкт-Петербурге. «Паруса на крыше» — купола Казанского собора на уровне взгляда из панорамного зала. Бронирование.",
    "keywords": "ресторан вид казанский собор петербург, казанский собор вид ресторан спб, ужин вид казанский собор",
    "date": "2026-06-07",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Казанский собор — одна из самых красивых архитектурных доминант Петербурга. Смотреть на него с высоты, на уровне колоннады — привилегия, доступная лишь из нескольких точек в городе.",
    "sections": [
      {
        "heading": "Вид на Казанский собор из «Парусов на крыше»",
        "body": "«Паруса на крыше» на 6-м этаже Olympic Plaza (ул. Марата, 5) — один из немногих ресторанов Петербурга, откуда Казанский собор виден на уровне взгляда. С этой высоты открывается верхняя часть колоннады и купол — ракурс, который невозможно получить с улицы. В разное время суток собор выглядит по-разному: золото купола в полуденном солнце, силуэт на закатном небе, огни подсветки ночью.",
        "list": [
          "Купол Казанского собора — виден из северных окон зала",
          "Высота обзора совпадает с верхней частью колоннады",
          "Ночная подсветка собора — особый вид после 22:00",
          "Расстояние от ресторана до собора — около 700 метров"
        ]
      },
      {
        "heading": "Казанский собор как достопримечательность",
        "body": "Казанский собор (1811) — шедевр русского классицизма, созданный по образцу собора Святого Петра в Риме. Его колоннада из 96 колонн полукругом охватывает небольшой сквер на Казанской площади. С уровня 6-го этажа хорошо виден именно этот полукруг и купол над ним — масштаб, который с улицы ощутить сложнее."
      },
      {
        "heading": "Лучшее время суток для вида на Казанский",
        "body": "Дневной свет (12:00–16:00): чёткие силуэты, детали купола. Закатное освещение (лето 20:00–22:00, осень 16:00–18:00): купол горит золотом. Ночь: собор освещён прожекторами — белые колонны на тёмном небе. Каждый вариант по-своему красив. Для романтического ужина — закат или ночная подсветка.",
        "highlight": "Запрашивайте «столик с видом на север» при бронировании — именно с северной стороны зала виден Казанский собор. Телефон: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать стол с видом на Казанский собор",
      "href": "/"
    }
  },
  {
    "slug": "restorany-v-olimpik-plaza-spb",
    "title": "Ресторан на 6-м этаже Olympic Plaza в Петербурге",
    "metaTitle": "Ресторан в Olympic Plaza Петербург — 6 этаж | Паруса на крыше",
    "metaDescription": "Ресторан «Паруса на крыше» в Olympic Plaza Санкт-Петербурга — 6-й этаж, панорама исторического центра. Авторская кухня, живая музыка, рейтинг 5,0. Бронирование.",
    "keywords": "ресторан 6 этаж olympic plaza петербург, olympic plaza спб ресторан, ресторан марата 5 петербург этаж",
    "date": "2026-06-08",
    "category": "Гид по городу",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "Olympic Plaza на улице Марата, 5 — один из немногих многофункциональных комплексов в историческом центре Петербурга. На 6-м этаже расположен ресторан «Паруса на крыше» — главная достопримечательность здания.",
    "sections": [
      {
        "heading": "Olympic Plaza: что это за здание",
        "body": "Olympic Plaza (ул. Марата, 5) — многофункциональный комплекс в Центральном районе Петербурга, в нескольких минутах ходьбы от Невского проспекта. Здание включает торговую зону, офисы и на 6-м этаже — ресторан «Паруса на крыше». Именно ресторан является главной причиной, по которой петербуржцы знают это здание: 15 лет работы, рейтинг 5,0 при 2 606 отзывах.",
        "list": [
          "Адрес: ул. Марата, 5, Olympic Plaza, 6-й этаж",
          "Метро: Маяковская (5 мин.) или Достоевская (7 мин.)",
          "Парковка: подземная парковка Olympic Plaza",
          "Работает с 2009 года — один из старейших панорамных ресторанов центра"
        ]
      },
      {
        "heading": "Как найти ресторан",
        "body": "Главный вход в Olympic Plaza — с ул. Марата. Войдя, найдите лифты в центральной части здания. 6-й этаж — последний. На выходе из лифта будут указатели к ресторану. Вход в сам ресторан открыт — бронирование позволяет занять конкретный столик."
      },
      {
        "heading": "Парковка и общественный транспорт",
        "body": "Метро — самый удобный вариант: Маяковская (линия 3) или Достоевская (линия 5), 5–7 минут пешком. Автомобиль: подземная парковка в здании Olympic Plaza, платная. Такси: адрес «Olympic Plaza, ул. Марата 5, Санкт-Петербург».",
        "highlight": "Ориентир для навигатора: «Olympic Plaza, улица Марата 5». Вход с ул. Марата, лифт на 6-й этаж."
      }
    ],
    "cta": {
      "text": "Забронировать стол в Olympic Plaza",
      "href": "/"
    }
  },
  {
    "slug": "restorany-s-avtorskoy-kukhney-peterburg",
    "title": "Рестораны с авторской кухней в Петербурге: куда пойти",
    "metaTitle": "Рестораны с авторской кухней в Петербурге 2026 — Паруса на крыше",
    "metaDescription": "Рестораны с авторской кухней в Санкт-Петербурге. Что такое авторская кухня, где её найти и что заказывать. «Паруса на крыше» — авторская кухня с видом на город.",
    "keywords": "рестораны авторская кухня петербург, авторская кухня ресторан спб, куда пойти авторская кухня петербург",
    "date": "2026-06-08",
    "category": "Гид по городу",
    "readTime": 7,
    "image": "/photos/food.webp",
    "lead": "Авторская кухня в Петербурге — модный термин, который скрывает очень разные вещи. Разбираем, что за ним стоит, как отличить настоящее от маркетинга и где найти лучшие примеры.",
    "sections": [
      {
        "heading": "Что такое авторская кухня",
        "body": "Авторская кухня — это когда шеф-повар создаёт оригинальные блюда, а не воспроизводит стандартные рецепты. Признаки: сезонное меню (меняется несколько раз в год), использование локальных продуктов (карельские грибы, балтийская рыба, новгородские ягоды), неожиданные сочетания вкусов при сохранении гармонии, фирменные блюда, которых нет в других ресторанах. В «Парусах на крыше» всё это есть: меню обновляется регулярно, шеф работает с сезонными продуктами региона.",
        "list": [
          "Сезонное меню — обновляется весной, летом, осенью, зимой",
          "Локальные продукты: балтийская рыба, карельские грибы",
          "Фирменные блюда: гребешки, карпаччо, хоспер-блюда",
          "Авторские десерты: по рецептам шеф-кондитера"
        ]
      },
      {
        "heading": "Как отличить авторскую кухню от имитации",
        "body": "Фальшивая авторская кухня: то же меню что в соседнем ресторане, маленькие порции за большие деньги, «авторские» блюда с одинаковыми банальными вкусами. Настоящая авторская кухня: каждый приход — что-то новое, блюда вызывают разговор («а что это такое?»), вкусы запоминаются после ужина. В «Парусах» гости в отзывах часто упоминают конкретные блюда по названию — признак того, что кухня действительно запомнилась."
      },
      {
        "heading": "Что заказывать в первый раз",
        "body": "При первом визите в ресторан с авторской кухней спросите официанта: «что из фирменных блюд рекомендуете?». Хорошая команда даст 2–3 конкретных совета. В «Парусах» традиционно рекомендуют: гребешки на открытие, что-то с хоспера как главное, авторский десерт шеф-кондитера на финал. Это классический сет, который отражает суть кухни. Читайте также: <a href=\"/blog/avtorskaya-kukhnya-peterburg-trendy\" class=\"underline text-accent\">авторская кухня Петербурга: тренды</a>.",
        "highlight": "Первый визит: попросите «дегустационный ужин» из 4–5 блюд по выбору шефа — это лучший способ познакомиться с кухней ресторана."
      }
    ],
    "cta": {
      "text": "Попробовать авторскую кухню",
      "href": "/menu"
    }
  },
  {
    "slug": "restorany-morепродукты-peterburg",
    "title": "Рестораны с морепродуктами в Петербурге: где вкусно",
    "metaTitle": "Рестораны с морепродуктами в Петербурге 2026 — Паруса на крыше",
    "metaDescription": "Рестораны с морепродуктами в Санкт-Петербурге. Где вкусно поесть устрицы, гребешки, крабы? «Паруса на крыше» — морепродукты в авторском меню, вид на город.",
    "keywords": "рестораны морепродукты петербург, морепродукты ресторан спб, устрицы гребешки ресторан петербург",
    "date": "2026-06-08",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Петербург — портовый город на Балтике. Морепродукты здесь — не экзотика, а традиция. Свежие гребешки, устрицы, краб, балтийская рыба — всё это доступно в хороших ресторанах города.",
    "sections": [
      {
        "heading": "Морепродукты в меню «Парусов на крыше»",
        "body": "В «Парусах» морепродукты — одна из главных тем меню. Фирменная позиция: гребешки с цветной капустой и икрой — блюдо, которое регулярно появляется в отзывах как «нужно обязательно попробовать». Также: карпаччо из тунца, тигровые креветки в разных интерпретациях, рыбные блюда по сезону. Авторский подход: морепродукты сочетают с необычными гарнирами и соусами, создавая блюда с петербургским характером.",
        "list": [
          "Гребешки с цветной капустой и икрой — фирменное блюдо",
          "Карпаччо из тунца — лёгкая закуска",
          "Тигровые креветки: в нескольких интерпретациях",
          "Рыбные блюда по сезону — меняются несколько раз в год"
        ]
      },
      {
        "heading": "Сезонность морепродуктов",
        "body": "Морепродукты имеют свою сезонность. Гребешок: лучший осенью и зимой (нагуливается всё лето). Устрицы: традиционно «сезон устриц» — сентябрь-май (в месяцы без «р» вкус хуже). Краб: нет жёсткого сезона, но зимой часто крупнее. Рыба: балтийская треска и лосось — круглогодично. Шеф «Парусов» следит за сезонностью и меняет меню соответственно."
      },
      {
        "heading": "Как выбрать морепродукты в меню",
        "body": "Практические советы: спросите официанта, что сегодня особенно свежее. Начните с одной-двух закусок из морепродуктов, прежде чем переходить к горячему. Гребешки хорошо есть отдельно или с лёгким гарниром — не заглушайте вкус. Вино к морепродуктам: белое или розовое, лучше сухое — просите рекомендацию у официанта.",
        "highlight": "Лучшее сочетание: гребешки + бокал совиньон блан или шабли. Спросите официанта в «Парусах» — они знают, что сочетается лучше всего."
      }
    ],
    "cta": {
      "text": "Посмотреть меню с морепродуктами",
      "href": "/menu"
    }
  },
  {
    "slug": "restorany-uytnyye-peterburg",
    "title": "Самые атмосферные рестораны СПб: где создаётся настроение",
    "metaTitle": "Самые атмосферные рестораны СПб — Паруса на крыше",
    "metaDescription": "Самые атмосферные рестораны Санкт-Петербурга. Что создаёт особую атмосферу и где её найти. «Паруса на крыше» — вид, музыка, авторская кухня, 15 лет репутации.",
    "keywords": "атмосферные рестораны спб, атмосфера ресторан петербург, уютные атмосферные рестораны спб",
    "date": "2026-06-09",
    "category": "Гид по городу",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "Атмосфера ресторана — то, что невозможно описать, но сразу чувствуется при входе. Правильная атмосфера создаётся не дизайном и не меню по отдельности, а их сочетанием. Разбираем, что составляет ресторанную атмосферу.",
    "sections": [
      {
        "heading": "Из чего строится атмосфера",
        "body": "Исследования в области потребительского поведения выделяют пять факторов ресторанной атмосферы: звук (уровень шума, музыка), свет (интенсивность, тепло/холод), запах (аромат кухни, отсутствие посторонних запахов), пространство (расстояние между столами, высота потолков), и главный — вид. В «Парусах на крыше» все пять факторов работают правильно: живая музыка вполголоса, тёплое освещение, аромат кухни, свободная расстановка столов и панорама Петербурга.",
        "list": [
          "Звук: живая музыка + правильная акустика = комфортный фон",
          "Свет: тёплое освещение, свечи вечером",
          "Пространство: столы не стоят вплотную",
          "Вид: главный атмосферный элемент — панорама Петербурга"
        ]
      },
      {
        "heading": "Что особенного в атмосфере «Парусов»",
        "body": "15 лет работы — это не просто опыт, это «характер» места. Рестораны с историей имеют особую атмосферу, которую невозможно создать искусственно: постоянные гости, которых знают по имени, особые традиции (живая музыка по расписанию, сезонное меню), интерьер, который «обжился» со временем. Это то, что гости описывают в отзывах как «я здесь как дома, но лучше»."
      },
      {
        "heading": "Когда атмосфера особенно сильная",
        "body": "Лучшие моменты в «Парусах»: пятница вечером с живым джазом и закатным небом за окном. Зимний вечер в декабре с огнями города и глинтвейном. Летняя терраса в белые ночи в 23:00. Романтический ужин при свечах в будний вечер, когда зал почти пустой. Каждый из этих моментов создаёт своё особое ощущение места.",
        "highlight": "Чтобы почувствовать атмосферу «Парусов» в лучшем виде: забронируйте пятничный вечер с живой музыкой в летний период. Телефон: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Почувствовать атмосферу: забронировать",
      "href": "/"
    }
  },
  {
    "slug": "luchshie-restorany-uzhin-spb",
    "title": "Лучшие рестораны для ужина в СПб: куда пойти вечером",
    "metaTitle": "Лучшие рестораны для ужина в СПб 2026 — Паруса на крыше",
    "metaDescription": "Лучшие рестораны для ужина в Санкт-Петербурге 2026. Где вкусно поужинать? «Паруса на крыше» — авторская кухня, вид на Петербург, живая музыка. Бронирование.",
    "keywords": "лучшие рестораны ужин спб, где поужинать петербург, рестораны для ужина санкт-петербург",
    "date": "2026-06-09",
    "category": "Гид по городу",
    "readTime": 7,
    "image": "/photos/view_night.webp",
    "lead": "Петербургский ужин — это не просто прием пищи. Это вечер в городе с историей, правильным рестораном и хорошей компанией. Где лучше всего ужинать в Петербурге — вопрос, на который каждый год отвечают по-новому.",
    "sections": [
      {
        "heading": "Что делает ужин в Петербурге особенным",
        "body": "Петербург — вечерний город. Его архитектура лучше всего работает в вечернем освещении: подсветка куполов, огни набережных, отражения в Неве. Ужин с видом на это — часть петербургского опыта, которого нет ни в одном другом городе России. «Паруса на крыше» дают этот опыт в концентрированном виде: вид на вечерний Петербург с 6-го этажа + авторская кухня + живая музыка.",
        "list": [
          "Вечерний Петербург с высоты — уникальный опыт",
          "Авторская кухня — блюда, которые запоминаются",
          "Живая музыка по выходным — атмосфера без дополнительных усилий",
          "Рейтинг 5,0 при 2 606 отзывах — объективно лучший в категории"
        ]
      },
      {
        "heading": "Разные поводы для ужина в «Парусах»",
        "body": "Ужин без повода в пятницу: просто конец недели и хорошее место. Романтический ужин для двоих: все инструменты есть — свечи, вид, музыка. День рождения: скидка 20% именинникам, возможность заказать живую музыку. Деловой ужин: нейтральная территория высокого класса. Семейный ужин: кухня для любого возраста, просторный зал."
      },
      {
        "heading": "Практика: когда и как бронировать",
        "body": "Будни: можно прийти без брони, но лучше с ней — особенно у окна. Выходные: бронировать за 3–5 дней. Праздники (14 февраля, 8 Марта, НГ): за 2–3 недели. Особые вечера (предложение, юбилей): минимум за 5–7 дней с пометкой о поводе.",
        "highlight": "Лучший совет: пятница, 19:30, столик у западного окна. Живая музыка + закат + вид на Казанский собор = идеальный петербургский вечер."
      }
    ],
    "cta": {
      "text": "Забронировать ужин в «Парусах»",
      "href": "/"
    }
  },
  {
    "slug": "top-restoranы-obyed-tsentr-peterburg",
    "title": "Топ ресторанов для обеда в центре Петербурга",
    "metaTitle": "Топ ресторанов для обеда в центре Петербурга — Паруса на крыше",
    "metaDescription": "Лучшие рестораны для обеда в центре Санкт-Петербурга. Бизнес-ланч, авторская кухня, вид на город. «Паруса на крыше» — бизнес-ланч от 590 ₽ с панорамой.",
    "keywords": "топ рестораны обед центр петербург, ресторан обед центр спб, лучший обед центр петербург",
    "date": "2026-06-09",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Обед в центре Петербурга — ежедневная задача для тысяч офисных работников, туристов и местных. Разброс предложений огромный: от бизнес-ланча за 500 ₽ до авторского обеда за 3 000 ₽. Где найти лучшее?",
    "sections": [
      {
        "heading": "Что искать в ресторане для обеда в центре",
        "body": "Ключевые критерии: скорость (обеденный перерыв ограничен), качество (хочется поесть хорошо, а не заправиться), цена (должна вписываться в рабочий бюджет), атмосфера (хочется выйти из офисного режима хотя бы на час). «Паруса на крыше» закрывают все четыре: бизнес-ланч от 590 ₽ подаётся быстро, блюда авторские, панорама переключает режим лучше любого перерыва.",
        "list": [
          "Бизнес-ланч от 590 ₽ — будни 12:00–16:00",
          "Скорость подачи — ориентированы на обеденный поток",
          "Авторская кухня при ценах бизнес-ланча",
          "Вид на Петербург — психологический «перезапуск» после утра"
        ]
      },
      {
        "heading": "Бизнес-ланч vs. à la carte на обед",
        "body": "Бизнес-ланч выгоднее: те же продукты, что и à la carte, в обеденном формате за 30–50% меньше. В «Парусах» бизнес-ланч включает закуску или суп + горячее + напиток. Для тех, кто хочет чуть больше — можно добавить à la carte десерт (400–600 ₽) и превратить ланч в небольшую гастрономическую паузу."
      },
      {
        "heading": "Другие рестораны для обеда в центре",
        "body": "В центре Петербурга много вариантов бизнес-ланча. Ориентир при выборе: рейтинг 4,5+ при 100+ отзывах, реальные фото блюд в отзывах, наличие свободных мест (лучше бронировать). «Паруса на крыше» с рейтингом 5,0 — верхняя строчка любого такого рейтинга. Подробнее о обеде в «Парусах»: <a href=\"/blog/lanch-v-panoramnom-restorane-spb\" class=\"underline text-accent\">ланч в панорамном ресторане</a>."
      }
    ],
    "cta": {
      "text": "Забронировать бизнес-ланч",
      "href": "/menu"
    }
  }
];
